export default 'logsPage';
